import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1040px;
  margin: 16px auto 24px;
  padding: 20px 16px 28px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  gap: 18px;
  backdrop-filter: blur(8px);
  font-size: 16px;
  
  ul {
    padding: 10px 20px;
    margin: 0;
    
    li {
      margin-bottom: 8px;
      position: relative;
      padding-left: 5px;
      line-height: 1.5;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const VersionInfo = styled.span`
  font-weight: bold;
  font-size: 17px;
  color: #1a237e;
  display: flex;
  align-items: center;
  
  span {
    font-weight: normal;
    font-size: 14px;
    color: #666;
    margin-left: 12px;
  }
`;
